// import * as React from 'react';
import { TvmWalletServiceProvider } from '@broxus/tvm-connect/lib';
import eruda from 'eruda';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';

import { tvmWalletService } from '@/services/tvm';

import App from './App.tsx';
import '@/styles/index.scss';
import '@broxus/tvm-connect/uikit.min.css'; // include all required styles from UIkit
import '@broxus/tvm-connect/style.min.css'; // include all required styles from TVM Connect
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary.tsx';
import { store } from './store';
import { isDevelopment } from './utils/mode.ts';

store.errorHandler.init();

if (isDevelopment) {
  eruda.init();
}

createRoot(document.getElementById('root')!).render(
  <>
    <ErrorBoundary>
      <TvmWalletServiceProvider wallet={tvmWalletService}>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <IntlProvider locale="en" defaultLocale="en">
            <App />
          </IntlProvider>
        </BrowserRouter>
      </TvmWalletServiceProvider>
    </ErrorBoundary>
  </>,
);
